import React, { FC } from 'react'

import { cx } from '@linaria/core'
import { styled } from '@linaria/react'

import { WithClassName, WithDataName } from 'common/types'

import { Typography } from '../Typography/Typography'

const maximumValue = 99

export const BadgeCounter: FC<
  WithClassName & WithDataName & { counter: number }
> = ({ className, counter, ...rest }) => {
  const _counter = counter > maximumValue ? `${maximumValue}+` : counter

  return (
    <Parent
      className={cx(className)}
      fontSize={11}
      fontWeight={700}
      tag="span"
      data-name={rest['data-name']}
    >
      {_counter}
    </Parent>
  )
}

const Parent = styled(Typography)`
  display: inline-flex;
  padding: var(--spacing-2px) var(--spacing-8px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: var(--error-default);
  color: var(--mamba-on-mamba);
`
